import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { NotificationLogModel } from '@models/notification-log-model';
import { NotificationLogService } from '@services/notification-log.service';
import { LocalizationService } from '@services/localization.service';

@Component({
  selector: 'app-notification-log-popup',
  templateUrl: './notification-log-popup.component.html',
  styleUrls: ['./notification-log-popup.component.scss']
})
export class NotificationLogPopupComponent implements OnInit {
  notificationLog: NotificationLogModel;

  constructor(
    public dialog: MatDialogRef<NotificationLogPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public popupData: any,
    private service: NotificationLogService,
    public localeService: LocalizationService
  ) {
    dialog.disableClose = true;
  }

  ngOnInit() {
    this.notificationLog = this.popupData.notificationLog;
  }

  close() {
    if (this.popupData.markRead === false) {
      this.dialog.close();
    } else {
      this.service.markRead(this.notificationLog).subscribe(dateRead => {
        this.dialog.close(dateRead);
      });
    }
  }
}
